import { Visitor } from 'src/features/visitor/types';
import axios from 'src/lib/axios';
import { ListResponseSmartParkAPI } from 'src/lib/queries';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/visitors/visitor/`;

interface DTO {
    parkingId: string;
    search: string;
}

const searchVisitor = ({ parkingId, search }: DTO): Promise<ListResponseSmartParkAPI<Visitor>> =>
    axios.get(formatResourcePath(RESOURCE, { parkingId }), { params: { search } });

export { RESOURCE as SEARCH_VISITOR_RESOURCE, searchVisitor };
